import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeRoleModal } from "../../Store/Slices/brSlice";
import AddRole from './AddRole';
import DeleteRole from './DeleteRole';
import EditRole from './EditRole';
import { useState } from 'react';
import { useEffect } from 'react';

const RolesDialog = () => {

    const dispatch = useDispatch();
    const br = useSelector((state) => state.roles);
    const [roles, setRoles] = useState("")

    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("role"));
        }
      }
      getRoles()
    }, [])

    let content;
    let deleteView = false

    const handleClose = () => {
      dispatch(closeRoleModal(false))
    }

    if (br.modalStatus === "add") {
      content = roles?.split(",").includes("PRIV_ECOM_ADDBR") && <AddRole handleClose={() => handleClose()} />;
    } else if (br.modalStatus === "edit") {
      content = roles?.split(",").includes("PRIV_ECOM_EDITBR") && <EditRole handleClose={() => handleClose()} />;
    } else if (br.modalStatus === "delete") {
      deleteView = true
      content = roles?.split(",").includes("PRIV_ECOM_DELETEBR") && <DeleteRole/>;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                sx={{
                  marginLeft: deleteView ? '25rem' : '15rem',
                  marginRight: deleteView ? '25rem' : '15rem',
                  maxWidth: deleteView ? 'fit-content' : 'none'
                }}
                open={br.modalStatus === "add" || br.modalStatus === "edit" || br.modalStatus === "delete"}
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    )
}

export default RolesDialog